// Mirrors CREDITS_PER_DOLLAR in the API's onboarding-chat module.
export const CREDITS_PER_DOLLAR = 100;

const usdFormatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

export function formatCreditsAsUsd(credits: number): string {
  const safeCredits = Number.isFinite(credits) && credits > 0 ? credits : 0;
  return usdFormatter.format(safeCredits / CREDITS_PER_DOLLAR);
}
